/**Angular imports */
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import { Component, OnDestroy, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import {
  debounceTime, takeWhile
} from 'rxjs/operators';
/**Services */
import { Utilities } from '../../../../../shared/outer-services/utilities.service';

/**Components */
import { OCCPageState, OccTextState, OccSettingsTextState, FrameworkConfigState } from '../../../../../state-management/state/main-state';
import { CareersJrSnackBar } from '../../careersJr-modal/careersJr-modal-component';
import { CareersJrApiCallClass } from '../../careersJr-constants/model';
import { CareersJrDispatchService } from '../../careersJr-services/careersJr-dispatch.service';
import { CareersJrApiCallService } from '../../careersJr-services/careersJr-apicalls.service';
import { CareersJr_Settings_Tab_Text_State, CareersJr_Index_Reducer_Text_State, CareersJr_Buttons_Reducer_Text_State, CareersJr_EmpOutlook_Wages_State } from '../../careersJr-state-management/careersJr-state/careersJr-state';
import { CareersJrCommonMethodsService } from '../../careersJr-services/careersJr-common-methods.service';
import { EventDispatchService } from '../../../../../shared/outer-services/event-dispatch.service';
import { StorageService } from '../../../../../shared/outer-services/storage.service';
import { DataJrExchangeService } from '../../careersJr-services/dataJr-exchange.service';
@Component({
  selector: 'careersJr-cluster-header',
  templateUrl: './careersJr-cluster-layout.html',
  standalone: false
})
export class CareersJrClusterHeaderComponent implements OnInit, OnDestroy {
  currentRate; /**Declare for storing the current rating value.*/
  value = 'At a Glance'; /**Declare for storing the tab value.*/
  refGlance = {}; /**Declare for storing the icon and cluster color values.*/
  starRes; /**Declare for storing the rating values.*/
  refrelatedcareer = {
    RelatedCareers: {},
  }; /**Declare for storing the career icon and color values.*/
  clusterID = ''; /**Declare for storing the related clusterIDs.*/
  clusterName; /**Declare for storing the cluster related text coming from store.*/
  //nameTxt; /**Declare for storing the text of different language.*/
  showColorUp = -1; /**Declare for storing the thumbs value.*/
  clusterIcon = ''; /**Declare for storing the cluster icon.*/
  clusterColor = ''; /**Declare for storing the cluster color.*/
  accountID = ''; /**Declare for storing the accountID.*/
  backAssessmentValue =
    false; /**Declare for storing the value for backtoAssessment.*/
  occClusterText; /**Declare for storing the cluster text.*/
  hideVal = 0; /**Declare for storing the hide values.*/
  occClusterStore; /**Declare for storing the text coming from the store.*/
  activeVal = 0;
  langChange = false; /**Declare for storing the active values.*/
  clussettingsText; /**Declare for storing the settings subscribe text.*/
  occIndexReducerSub =
    new Subscription(); /** Declare to listen if any change occured.*/
  outereventsubscription = new Subscription();
  langVal; /**Declare for getting the language value.*/
  filter: any; /** boolean value toggle in mobile  */
  public snackbar =
    new CareersJrSnackBar(); /**Declare for showing the snackbar. */
  occID = ''; /** Contains current occId value */
  occclusinx = '';
  frameworkObj;
  logo;
  restrictedAccountConstant; /**Variable used to store restrictedaccounttype  */
  accountTypeJwt; /**Variable used to store accounttype from JWT */
  restrictedAccountType: boolean;
  @ViewChild('videoplayer') videoplayer: ElementRef;
  @ViewChild('occClusterFocus', { static: true })
  occClusterFocusElement: ElementRef;
  compActive = true;

  tabClicked: string;
  private goToCareerSub: Subscription;
  isPlaying: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private careersJrstore: Store<any>,
    private apiJson: CareersJrApiCallClass,
    private careersJrDispatch: CareersJrDispatchService,
    private ratingConfig: NgbRatingConfig,
    private router: Router,
    private careersJrApiCall: CareersJrApiCallService,
    private store: Store<any>,
    private careersJrSetstore: Store<CareersJr_Settings_Tab_Text_State>,
    private dispatchStore: Store<Action>,
    private careersJrPageStateStore: Store<CareersJr_EmpOutlook_Wages_State>,
    private careersJrIndexstore: Store<CareersJr_Index_Reducer_Text_State>,
    private careersJrCommonService: CareersJrCommonMethodsService,
    private utils: Utilities,
    private storageService: StorageService,
    private eventService: EventDispatchService,
    private Frameworkstore: Store<FrameworkConfigState>,
    @Inject('RESTRICTED_ACCOUNT_TYPE') public restrictedAccount: string,
    @Inject('CAREER_IMAGE_URL') public CareersImages: string,
    private dataJrExchangeService: DataJrExchangeService
  ) {
    this.eventService
      .listen()
      .pipe(takeWhile(() => this.compActive))
      .subscribe((e) => {
        if (e.type == 'languageChanged') {
          this.langVal = this.storageService.sessionStorageGet('langset');
          const Arr = this.router.url.split('?');
          const routArr = Arr[0].split('/');
          this.hideVal = 0;
          this.langChange = true;
          this.ngOnInit();
        }
      });
    this.accountTypeJwt = this.utils.getDecodedAccessToken().accountType;
    this.restrictedAccountConstant = restrictedAccount;
    if (this.accountTypeJwt !== this.restrictedAccountConstant) {
      this.restrictedAccountType = true;
    } else {
      this.restrictedAccountType = false;
    }
    this.storageService.sessionStorageSet('activeSortId', 'fileOcc');
    document.title = 'Careers';
    this.Frameworkstore.select('config')
      .pipe(takeWhile(() => this.compActive))
      .subscribe((res) => {
        if (res.config) {
          this.frameworkObj = res.config;
        }
      });
    const ref = this;
    function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = function () {
        let canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        let dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        try {
          dataURL = canvas.toDataURL(outputFormat);
          callback(dataURL);
          canvas = null;
        } catch (e) {
        } finally {
          dataURL =
            'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
          callback(dataURL);
          canvas = null;
        }
      };
      img.src = url;
    }
    convertImgToDataURLviaCanvas(
      ref.frameworkObj.Result.user.logo,
      function (base64Img) {
        ref.logo = base64Img;
      },
      'base64'
    );
    this.utils.showLoading();
    this.langVal = this.storageService.sessionStorageGet('langset');
    this.dispatchStore.dispatch({ type: 'RESET_CAREERSJR_SETTING_TABS_TEXT' });
    this.dispatchStore.dispatch({ type: 'RESET_OCC_PAGE' });
    if (
      !this.storageService.sessionStorageGet('CareersJrIndexReducerText') ||
      !this.storageService.sessionStorageGet('CareersJr_Reducer_OccText')
    ) {
      this.careersJrCommonService.OccIndexDispatch();
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      // Get occId from parameters
      this.occID = params['occid'];
      this.occclusinx = params['inx'];
      this.refGlance['iconName'] = this.clusterIcon;
      this.refGlance['clusterColor'] = this.clusterColor;
      // Get key value to nameTxt using occID
    });
    this.ratingConfig.max = 1;
    const rtArr = this.router.url.split('/');
    this.occIndexReducerSub = this.careersJrIndexstore
      .select('CareersJr_Index_Reducer_Text')
      .pipe(debounceTime(100))
      .subscribe((v) => {
        if (this.storageService.sessionStorageGet('parentCnt') == 'true') {
          this.savedClusNames();
        }
      });
    this.careersJrSetstore
      .select('CareersJr_Settings_Tab_Text')
      .pipe(takeWhile(() => this.compActive))
      .subscribe((v) => {
        this.clussettingsText = v;
        // console.log('clussettingsText',this.clussettingsText);
        this.hideLoadingSymbol();
      });
    this.careersJrstore
      .select('CareersJr_Buttons_Reducer_Text')
      .pipe(takeWhile(() => this.compActive))
      .subscribe((v) => {
        // if (this.langChange == true) {
        this.occClusterText = v;
        // console.log('this.occClusterText',this.occClusterText);
        // }
      });
    this.occClusterStore = this.careersJrPageStateStore.select(
      'CareersJr_EmpOutlook_Wages'
    );
    if (
      this.storageService.sessionStorageGet('inTab') != undefined ||
      this.storageService.sessionStorageGet('inTab') != null
    ) {
      if (
        this.storageService.sessionStorageGet('inTab') == 'Assess' ||
        this.storageService.sessionStorageGet('inTab') == 'cciAssess' ||
        this.storageService.sessionStorageGet('inTab') == 'osAssess'
      ) {
        this.backAssessmentValue = true;
      } else {
        this.backAssessmentValue = false;
      }
    }
    this.outereventsubscription = this.eventService
      .listenStaticContent()
      .subscribe((e) => {
        if (this.occClusterFocusElement) {
          this.occClusterFocusElement.nativeElement.setAttribute(
            'tabindex',
            '0'
          );
          this.occClusterFocusElement.nativeElement.focus();
        }
      });
  }


  videostop() {
    this.videoplayer.nativeElement.load();
    this.videoplayer.nativeElement.pause();
  }
  savedClusNames() {
    const val = JSON.parse(this.storageService.sessionStorageGet('CareersJrIndexReducerText'));
    const value = true;
    if (val && val.CareersJr_Index_Reducer_Text !== undefined) {
      val.CareersJr_Index_Reducer_Text.clusList.forEach((v) => {
        if (v.clusterID == this.clusterID && value == true) {
          this.clusterName = v.title;
        }
      });
    }
  }
  /**
   * This method is used to get into Occ Cluster component.
   */
  ngOnInit() {
    this.utils.showLoading();

    this.activatedRoute.queryParams
      .pipe(takeWhile(() => this.compActive))
      .subscribe((params) => {
        /** Defaults to 0 if no query param provided.*/
        this.clusterID = params['clusId'];
        this.clusterIcon = params['clusIcon'];
        this.clusterColor = params['clusColor'];
        this.refGlance['iconName'] = this.clusterIcon;
        this.refGlance['clusterColor'] = this.clusterColor;
        this.clusterName = params['clusName'];
        this.activeVal = 0;

        this.savedClusNames();
        this.accountID = 'accountID';
        this.dispatchStore.dispatch({
          type: 'GET_SECTIONS_TEXT',
          payload: {
            methodVal: 'GET',
            module_Name: 'OccJr/v2/',
            path_params: ['cluster', this.clusterID, this.accountID],
            query_params: {
              sections: 'all',
              lang: this.langVal,
            },
            body_Params: {},
            endUrlVal: 'pages',
            setVal: 'clusterPageResult',
            text: '',
          },
        });
      });
    this.savedClusNames();
    this.accountID = 'accountID';
    this.dispatchStore.dispatch({
      type: 'GET_SECTIONS_TEXT',
      payload: {
        methodVal: 'GET',
        module_Name: 'OccJr/v2/',
        path_params: ['cluster', this.clusterID, this.accountID],
        query_params: {
          sections: 'all',
          lang: this.langVal,
        },
        body_Params: {},
        endUrlVal: 'pages',
        setVal: 'clusterPageResult',
        text: '',
      },
    });
    let endVal;
    const logID = this.storageService.sessionStorageGet('logID');

    if (this.storageService.sessionStorageGet('inTab') == 'osAssess') {
      endVal =
        this.accountTypeJwt !== this.restrictedAccountConstant
          ? 'Users/pageText'
          : 'pageText/occSort';
    } else if (this.storageService.sessionStorageGet('module') == 'ideas') {
      endVal =
        this.accountTypeJwt !== this.restrictedAccountConstant
          ? 'Users/pageText'
          : 'pageText/ideas';
    } else if (this.storageService.sessionStorageGet('module') == 'rc') {
      endVal =
        this.accountTypeJwt !== this.restrictedAccountConstant
          ? 'Users/pageText'
          : 'pageText/realityCheck';
    } else {
      endVal =
        this.accountTypeJwt !== this.restrictedAccountConstant
          ? 'Users/pageText'
          : 'pageText/wil';
    }
    if (endVal === 'Users/pageText' && !logID) {
      this.getRating();
      this.refGlance['iconName'] = this.clusterIcon;
      this.refGlance['clusterColor'] = this.clusterColor;
      this.refrelatedcareer['clusterIcon'] = this.clusterIcon;
      this.refrelatedcareer['clusterColor'] = this.clusterColor;

      this.goToCareerSub = this.dataJrExchangeService.linkNameClicked.subscribe(name => {
        this.tabClicked = name;

        if (this.tabClicked === 'relatedCluster') {
          this.dropDownVal('Related Career ', 3)
          this.dataJrExchangeService.linkClickedByName('');
        }
      });
      return;
    }
    this.dispatchStore.dispatch({
      type: 'GET_INTRO_TEXT',
      payload: {
        methodVal: 'GET',
        module_Name: 'Assessment/v1/',
        path_params: endVal === 'Users/pageText' ? [logID] : [],
        query_params: { lang: this.langVal },
        body_Params: {},
        endUrlVal: endVal,
        setVal: 'commonIntro',
        text: '',
      },
    });
    this.getRating();
    this.refGlance['iconName'] = this.clusterIcon;
    this.refGlance['clusterColor'] = this.clusterColor;
    this.refrelatedcareer['clusterIcon'] = this.clusterIcon;
    this.refrelatedcareer['clusterColor'] = this.clusterColor;

    this.goToCareerSub = this.dataJrExchangeService.linkNameClicked.subscribe(name => {
      this.tabClicked = name;

      if (this.tabClicked === 'relatedCluster') {
        this.dropDownVal('Related Career ', 3)
        //reset the message
        // this.activeVal = 0;
        this.dataJrExchangeService.linkClickedByName(''); // Reset the message after using it
      }
    });
  }

  /**
   * This method is used for hiding the loading symbole after getting the entire data.
   */
  hideLoadingSymbol() {
    if (this.clusterName != undefined && this.clussettingsText != undefined) {
      if (
        this.clussettingsText.CareersJr_Settings_Tab_Text.topSections !=
        undefined
      ) {
        const ref = this;
        setTimeout(function () {
          ref.utils.hideLoading();
        }, 500);
      }
    }
  }

  /**
   * This method is used to get the cluster rating.
   */
  getRating() {
    try {
      this.apiJson.method = 'GET';
      this.apiJson.sessionID = this.storageService.sessionStorageGet('auth_key');
      this.apiJson.moduleName = 'OccJr/v2/';
      const getThumbsResult = {
        input_data: [
          {
            param_type: 'path',
            params: [this.accountID, 'ratings', this.clusterID],
          },
          {
            param_type: 'query',
            params: { lang: this.langVal },
          },
        ],
      };
      const user = JSON.stringify(getThumbsResult);
      this.apiJson.endUrl = 'users';
      this.apiJson.data = user;
      this.careersJrApiCall.callApi([this.apiJson]).subscribe(
        (res) => {
          if (res[0].Success + '' == 'true') {
            if (res[0].Result === 1) {
              this.showColorUp = 1;
            } else if (res[0].Result === 0) {
              this.showColorUp = 0;
            } else {
              this.showColorUp = -1;
            }
            this.getText();
          }
        },
        (e) =>
          this.utils.handleError(
            `careersJr-cluster-header-component.ts getRating: ${e.message}`
          )
      );
    } catch (e) {
      this.utils.handleError(
        `careersJr-cluster-header-component.ts getRating: exception ${e.message}`
      );
    }
  }

  /**
   *
   * @param thumbVal is used to indicate the thumb value.
   */
  getUnFill(thumbVal) {
    this.utils.showLoading();
    if (thumbVal == 'up' && this.showColorUp != 1) {
      this.showColorUp = 1;
    } else if (thumbVal == 'down' && this.showColorUp != 0) {
      this.showColorUp = 0;
    } else {
      this.showColorUp = -1;
    }
    this.resultPost();
  }
  resultPost() {
    setTimeout(
      function () {
        this.apiJson.method = 'POST';
        this.apiJson.sessionID = this.storageService.sessionStorageGet('auth_key');
        this.apiJson.moduleName = 'OccJr/v2/';
        const starResult = {
          input_data: [
            {
              param_type: 'path',
              params: [
                this.accountID,
                'ratings',
                this.clusterID,
                this.showColorUp,
              ],
            },
            {
              param_type: 'query',
              params: { lang: this.langVal },
            },
          ],
        };
        const user = JSON.stringify(starResult);
        this.apiJson.endUrl = 'users';
        this.apiJson.data = user;
        this.careersJrApiCall.callApi([this.apiJson]).subscribe(
          (res) => {
            if (res.Result + '' == 'true') {
              const val = JSON.parse(
                this.storageService.sessionStorageGet('CareersJrIndexReducerText')
              );
              // let resOcc =
              val.CareersJr_Index_Reducer_Text.clusList.forEach((res) => {
                if (res.clusterID == this.clusterID) {
                  res.rating = this.showColorUp;
                }
                //  return ;
              });
              // console.log('al is :' + JSON.stringify(val.commonText.occList));
              this.storageService.sessionStorageSet(
                'CareersJrIndexReducerText',
                JSON.stringify(val)
              );
              this.starRes = this.showColorUp;
              if (this.storageService.sessionStorageGet('prevRoute') === 'occSort') {
                const value = JSON.parse(this.storageService.sessionStorageGet('OSOnMyList'));
                value.OsGetAllOccList.clusList.forEach((clus) => {
                  if (clus.clusterID == this.clusterID) {
                    clus.rating = this.showColorUp;
                  }
                });
                this.storageService.sessionStorageSet('OSOnMyList', JSON.stringify(value));
              }
              this.utils.hideLoading();
              this.getRating();
            }
          },
          (e) =>
            this.utils.handleError(
              `careersJr-cluster-header-component.ts resultPost: ${e.message}`
            )
        );
      }.bind(this)
    );
  }
  /**
   * This method is  for getting the text from the store and display.
   */
  getText() {
    // if (this.langChange == false) {
    const val = JSON.parse(this.storageService.sessionStorageGet('CareersJr_Reducer_OccText'));
    if (
      val &&
      val.careersJr_Buttons_Reducer_Text &&
      val.careersJr_Buttons_Reducer_Text.common != undefined
    ) {
      this.occClusterText = val;
    }
    // }
    const asmtEndurl = this.restrictedAccountType
      ? 'OccJr/cluster'
      : 'OccJr/cluster/default';
    this.dispatchStore.dispatch({
      type: 'GET_CAREERSJR_SETTING_TABS_TEXT',
      payload: {
        methodVal: 'GET',
        module_Name: 'Settings/v1/',
        path_params: this.restrictedAccountType ? ['accountID'] : [],
        query_params: { lang: this.langVal },
        body_Params: {},
        endUrlVal: asmtEndurl,
      },
    });
  }

  /**
   * This method is used in the mobile view dropdown.
   * @param name is for storing the tab value.
   * @param num is for storing the index value.
   */
  dropDownVal(name, num) {
    this.value = name;
    this.activeVal = num;

    const evnt = document.createEvent('CustomEvent');
    evnt.initEvent(name, true, true);
    this.careersJrDispatch.dispatch(evnt);
  }
  /** This function is for saving the data as favorites */
  savePost() {
    try {
      this.utils.showLoading();
      this.apiJson.method = 'POST';
      this.apiJson.sessionID = this.storageService.sessionStorageGet('auth_key');
      this.apiJson.moduleName = 'OccJr/v2/';
      const saveResult = {
        input_data: [
          {
            param_type: 'path',
            params: [this.accountID, 'favorites', this.clusterID],
          },
          {
            param_type: 'query',
            params: { lang: this.langVal },
          },
        ],
      };
      const user = JSON.stringify(saveResult);
      this.apiJson.endUrl = 'users';
      this.apiJson.data = user;
      this.careersJrApiCall.callApi([this.apiJson]).subscribe(
        (res) => {
          this.utils.hideLoading();
          const evnt = document.createEvent('CustomEvent');
          evnt.initEvent('PlanCompStatus', true, true);
          this.eventService.dispatch(evnt);
          this.snackbar.myFunction('Successfully added to favorites.');
        },
        (e) =>
          this.utils.handleError(
            `careersJr-cluster-header-component.ts savePost: ${e.message}`
          )
      );
    } catch (e) {
      (e) =>
        this.utils.handleError(
          `careersJr-cluster-header-component.ts savePost: exception ${e.message}`
        );
    }
  }
  /**
   *
   * @param check is used for checking from which career we came from.
   */
  CareerList(check) {
    this.storageService.sessionStorageSet('careerJrShow', '0');
    this.router.navigate(['../careerJrIndex'], {
      relativeTo: this.activatedRoute,
      queryParams: { chk: check, occclusinx: this.occclusinx },
    });
  }
  /**
   * This method is for navigating to the occlist page.
   */
  backAssessment() {
    this.storageService.sessionStorageSet('fromCareers', 'yes');
    if (
      this.storageService.sessionStorageGet('inTab') != 'cciAssess' &&
      this.storageService.sessionStorageGet('inTab') != 'osAssess'
    ) {
      this.router.navigate(
        ['../../' + this.storageService.sessionStorageGet('prevRoute') + '/occlist'],
        { relativeTo: this.activatedRoute }
      );
    } else {
      this.router.navigate(
        ['../../' + this.storageService.sessionStorageGet('prevRoute') + '/result'],
        { relativeTo: this.activatedRoute }
      );
    }
  }
  clusterPrint() {
    const evnt = document.createEvent('CustomEvent');
    switch (this.activeVal) {
      case 0: {
        this.careersJrDispatch.clusterAtGlanceDispatch(evnt);
        break;
      }
      case 1: {
        this.careersJrDispatch.clusterThingsToKnowDispatch(evnt);
        break;
      }
      case 2: {
        this.careersJrDispatch.clusterEducationDispatch(evnt);
        break;
      }
      case 3: {
        this.careersJrDispatch.clusterRelatedCareerDispatch(evnt);
        break;
      }
    }
  }

  /**
   * This ngOnDestroy() function is call after Component destory.
   */
  ngOnDestroy() {
    this.compActive = false;
    this.occIndexReducerSub.unsubscribe();
    this.outereventsubscription.unsubscribe();
    this.storageService.removeSessionIndexes(true);
  }
  onVideoPlay() {
    this.isPlaying = !this.isPlaying;
  }
}

